import { DocumentSubType, DocumentTypes } from './../../../appconfig';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

import { CommonService, DocumentsService } from '../../services/common';
import { environment } from '../../../environments/environment';
// import { DocumentSubType } from '../../../appconfig';
import { IconList } from '../../../iconlist';
declare const $: any;

@Component({
  selector: 'app-kyc-pannel',
  templateUrl: './kyc-pannel.component.html',
  styleUrl: './kyc-pannel.component.scss'
})

export class KycPannelComponent implements OnInit, OnChanges {
  @Input() kycPannel: Observable<any> | undefined
  @Output() getKYCPannel = new EventEmitter<any>();
  @Input() userData: any
  documentFileData: any;
  displayDocumentFileDialogue: boolean = false;
  userDocuments: any = []

  showKycPanel: boolean = true;
  showLandPanel: boolean = false;

  aadharimg: any;
  aadharData: any;
  appaadhaarIcon = true;
  veriaadhaarIcon = false;
  adharHidden = false;


  appPanIcon = true;
  veriPanIcon = false;
  panHidden = false;

  addressHidden = false;
  bankHidden = false
  documentFile: any = [];
  assetsImagePath = environment.assetsImagePath
  userProfileImage: any = this.assetsImagePath + IconList.DefaultUserProfilePic
  userKYCAddharFrontPicIcon: any = this.assetsImagePath + IconList.AddIcon
  userKYCAddharBackPicIcon: any = this.assetsImagePath + IconList.AddIcon
  userKYCPanPicIcon: any = this.assetsImagePath + IconList.AddIcon
  userKYCAddressFrontPicIcon: any = this.assetsImagePath + IconList.AddIcon
  userKYCAddressBackPicIcon: any = this.assetsImagePath + IconList.AddIcon
  userKYCBankPicIcon: any = this.assetsImagePath + IconList.AddIcon
  aadharFrontDefaultPic: any = this.assetsImagePath + IconList.DefaultAadharFrontPic
  aadharBackdefaultPic: any = this.assetsImagePath + IconList.DefaultAadharBackPic
  panDefaultPic: any = this.assetsImagePath + IconList.DefaultPanCardPic
  addressDefaultPic: any = this.assetsImagePath + IconList.DefaultAddProofPic
  addressDefaultPicBack: any = this.assetsImagePath + IconList.DefaultAddProofPic
  chequeDefaultPic: any = this.assetsImagePath + IconList.DefaultBankCheqPic
  userProfilePicRecordExists: boolean = false
  documentSubType: any;
  isZoomed = false;
  enumArraydata: any = [DocumentSubType];

  largeViewPicFor: string = '';
  largeViewImage: string[] = [];
  constructor(public commonService: CommonService, private documentService: DocumentsService) { }

  ngOnInit() {
    this.getCurrentUserProfilePic();

  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //this.getCurrentUserDocumentList(this.userData?.userId);
    this.userDocuments = this.userData?.documentData;
    if (this.userDocuments != undefined) {
      this.processDocument()
    }
  }

  /**
   * In this method we are firstly validating that, is there documentSubTypeId (by comapring from DocumentSubType enum)
   *  is available in object or not if it is  available then using then using documentId of that object we are getting
   * documentByte and then populating every image of respective documentsubtype
   */
  processDocument() {
    this.userDocuments.forEach((doc: any) => {
      if (this.isValidSubType(doc.documentSubTypeId)) {
        +-
          this.documentService.getDocumentBytesById(doc.documentId).subscribe(
            (res: any) => {
              const documentPic = this.commonService.BaseStringToNormalString(res as string)
              // Assign base64Data to a specific variable based on the documentSubTypeId
              switch (doc.documentSubTypeId) {
                case DocumentSubType.Pan:
                  this.panDefaultPic = documentPic == null ? this.assetsImagePath + IconList["DefaultPanCardPic"] : documentPic; // Variable for PAN
                  this.userKYCPanPicIcon = this.documentService.getOperationIcon(documentPic);
                  break;
                case DocumentSubType.AadhaarFront:
                  this.aadharFrontDefaultPic = documentPic == null ? this.assetsImagePath + IconList.DefaultAadharFrontPic : documentPic; // Variable for Aadhaar Front
                  this.userKYCAddharFrontPicIcon = this.documentService.getOperationIcon(documentPic);
                  break;
                case DocumentSubType.AadhaarBack:
                  this.aadharBackdefaultPic = documentPic == null ? this.assetsImagePath + IconList.AadhaarCardBackDefaultPic : documentPic; // Variable for Aadhaar Back
                  this.userKYCAddharBackPicIcon = this.documentService.getOperationIcon(documentPic);
                  break;
                case DocumentSubType.Photo:
                  this.userProfileImage = documentPic; // Variable for Photo
                  break;
                case DocumentSubType.BankAccount:
                  this.chequeDefaultPic = documentPic == null ? this.assetsImagePath + IconList.DefaultBankCheqPic : documentPic;// Variable for Bank account
                  this.userKYCBankPicIcon = this.documentService.getOperationIcon(documentPic);

                  break;
                case DocumentSubType.VoterIdFront:
                  this.addressDefaultPic = documentPic == null ? this.assetsImagePath + IconList.DefaultAddProofPic : documentPic;
                  this.userKYCAddressFrontPicIcon = this.documentService.getOperationIcon(documentPic);
                  break;
                case DocumentSubType.VoterIdBack:
                  this.addressDefaultPicBack = documentPic == null ? this.assetsImagePath + IconList.DefaultAddProofPic : documentPic;
                  this.userKYCAddressBackPicIcon = this.documentService.getOperationIcon(documentPic);
                  break;
                // Add more cases as needed for other subtypes
                default:
                //this.setDefaultUserProilePic();
                // this.commonService.showError(`${doc.documentSubType} is not uploaded`);
              }
            }
          )
      }
    })
  }

  /**
   *validating that documentDubType includes in object or not
   * @param subTypeId
   * @returns
   */
  isValidSubType(subTypeId: number): boolean {
    return Object.values(DocumentSubType).includes(subTypeId);
  }

  /**
   * Sets config of current file to be uploaded. As common document-file component must know that current image is being
   * uploaded for which document sub type.
   * @param documentSubType "Sub Type of document for which file needs to be uploaded" (opptional)
   */
  setCurrentFileConfig(documentSubType: any) {
    if (this.documentFileData) {
      this.documentFileData.picFor = this.commonService.addSpaceInCamelCase(documentSubType)
      this.documentFileData.showDocumentNumber = true,
        this.documentFileData.userId = this.userData?.userProfileData?.id

    }
    else {
      this.documentFileData = this.documentService.setDocumentFileDataConfig(this.userData?.userProfileData?.id, DocumentSubType[documentSubType],
        this.commonService.addSpaceInCamelCase(documentSubType), true)
    }
    this.displayDocumentFileDialogue = true;

    if (this.documentSubType == 'BankAccount') {
      this.documentFileData.showDocumentNumber = false
    }
    this.documentFileData = {
      'documentId': this.userDocuments?.documentId,
      'documentSubTypeId': DocumentSubType[documentSubType],
      'documentNumber': this.documentFileData?.documentNumber,
      'picFor': documentSubType,
      'operationMode': this.userProfilePicRecordExists ? 'edit' : 'add',
      'showDocumentNumber': documentSubType !== 'BankAccount',
      "userId": this.userData?.userProfileData?.id
    }
    this.displayDocumentFileDialogue = true;
  }

  /**
   * Sets the default pics of user profile. Also, add icon by defalt for operation.
   */
  setDefaultUserProilePic() {
    this.userProfileImage = environment.assetsImagePath + IconList.DefaultUserProfilePic
    if (this.userProfilePicRecordExists)
      this.userKYCAddharFrontPicIcon = environment.assetsImagePath + IconList.EditIcon
    else
      this.userKYCAddharFrontPicIcon = environment.assetsImagePath + IconList.AddIcon
  }

  /**
   * Closes the Document file Modal
   */
  closeDocumentFileModal() {
    this.isZoomed = false;
  }

  /**
   *
   * @param receivedPicData Receives file from common document file control which is updated by user
   */
  receiveCurrentUploadedFile(receivedPicData: any) {
    //Make sure we have got any pic
    if (receivedPicData && receivedPicData?.documentFile && receivedPicData?.documentFile?.documentByte) {
      if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.AadhaarFront) {
        this.aadharFrontDefaultPic = receivedPicData?.documentFile?.documentByte;
        this.userKYCAddharFrontPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.UID;
        this.saveDocumentFile(receivedPicData.documentFile)
      }
      else if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.AadhaarBack) {
        this.aadharBackdefaultPic = receivedPicData?.documentFile?.documentByte;
        this.userKYCAddharBackPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.UID;
        this.saveDocumentFile(receivedPicData.documentFile)
      }
      else if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.Pan) {
        this.panDefaultPic = receivedPicData?.documentFile?.documentByte;
        this.userKYCPanPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.KYC;
        this.saveDocumentFile(receivedPicData.documentFile)
      }
      else if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.VoterIdFront) {
        this.addressDefaultPic = receivedPicData?.documentFile?.documentByte;
        this.userKYCAddressFrontPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.UID;

        this.saveDocumentFile(receivedPicData.documentFile)
      }
      else if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.VoterIdBack) {
        this.addressDefaultPicBack = receivedPicData?.documentFile?.documentByte;
        this.userKYCAddressBackPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.UID;

        this.saveDocumentFile(receivedPicData.documentFile)
      }
      else if (receivedPicData?.documentFile?.documentSubTypeId == DocumentSubType.BankAccount) {
        this.chequeDefaultPic = receivedPicData?.documentFile?.documentByte;
        this.userKYCBankPicIcon = environment.assetsImagePath + IconList.EditIcon;
        receivedPicData.documentFile["documentTypeId"] = DocumentTypes.KYC;
        this.saveDocumentFile(receivedPicData.documentFile)
      }
    }

    this.displayDocumentFileDialogue = false;
  }

  saveDocumentFile(documentFileData: any) {
    //Save document (Photo) file
    this.documentService.saveDoucmentFile(documentFileData)
  }

  /**
   * Gets the profile pic of current user
   * @param userId user id whose profile pic details has to be fetched
   */
  getCurrentUserProfilePic() {
    //by defaults we assume file id does not exists
    if (this.userData?.profilePicfile) {
      this.documentFileData = this.userData?.profilePicfile
      //if any profile pic already uploaded for current user then get the pic bytes else set default pic
      this.documentService.getDocumentBytesById(this.userData?.profilePicfile?.documentId).subscribe((profilePicRes: any) => {
        //if we find the profile pic on cloude then it display it
        if (profilePicRes) {
          this.userProfileImage = this.commonService.BaseStringToNormalString(profilePicRes)
          this.aadharFrontDefaultPic = environment.assetsImagePath + IconList.AadhaarCardFrontDefaultPic
        }
        else {
          //If document id exists but somehow pic deleted (in any case) from cloud then it will sent the default pic
          //but operatonit mode will be edit not add as file id already exists
          this.setDefaultUserProilePic()
        }
      })
    }
  }

  // Pan Card Save
  PanSave() {
    this.appPanIcon = false;
    this.veriPanIcon = true
    this.aadharimg = false
  }

  Landclick() {
    this.showKycPanel = false;
    //on property tab we need to show only property related documents
    this.userData.documentTypeId = [DocumentTypes.Property, DocumentTypes.Letters, DocumentTypes.PaymentReceipts];
    this.showLandPanel = true;
  }

  KYCClick() {
    this.showKycPanel = true;
    this.showLandPanel = false;
  }

  /**
   * KYC Header Tab Hide and Show
   */
  toggleAdharcard() {
    this.adharHidden = !this.adharHidden;
  }
  togglePancard() {
    this.panHidden = !this.panHidden
  }

  toggleAddress() {
    this.addressHidden = !this.addressHidden
  }

  toggleBankPassbook() {
    this.bankHidden = !this.bankHidden
  }

  picViewData: any;
  showclickedPic!: boolean;
  // Zooming Pic View Image
  zoomContent(images: string | string[], picFor: string) {
    if (typeof images === 'string') {
      this.largeViewImage = [images]
    } else {
      this.largeViewImage = images;
    }
    this.picViewData = {
      "picTitle": picFor,
      "picFile": this.largeViewImage,
    };
    this.showclickedPic = true;
    this.largeViewPicFor = picFor;
  }

  hidePicViewModal() {
    this.showclickedPic = false;
  }

  isActive = false;

  toggleAnimation() {
    this.isActive = !this.isActive;
  }
}
